<div *ngIf="!containsError" class="dispbuttonMargin">
  <div>
       <span class="pageHeader">
									{{pageHeader}}
       </span>

  </div>
  <br>
  <div class="errorMessage" *ngIf="errorMessage?.length">
    You must correct the following error(s) before proceeding:
    <li *ngFor="let message of errorMessage">{{message}}</li>
    <br>
  </div>
  <div *ngIf="!isSuccess">
    <div class="ui-g leftMarginAlignment" *ngIf="!isExternal">
      <div class="ui-g-2 lblAlign"> Enter Servicer Number (9 Digits):</div>
      <div class="ui-g-3"><input type="text" fmTextInput [maxLength]="9" [(ngModel)]="serviceNumber" (keypress)="this.utilService.numberOnly($event)"></div>
    </div>
    <div class="ui-g leftMarginAlignment">
      <div class="ui-g-2 lblAlign"> Select File Type:</div>
      <div class="ui-g-3">
        <div class="select-style">
          <fm-select [options]="types" [(ngModel)]="selectedFileType"></fm-select>
        </div>
      </div>
    </div>

    <div class="ui-g leftMarginAlignment">
      <div class="ui-g-12 ui-md-9">
        <fm-s3-fileupload #cdx_file_upload
                          [multiple]="false"
                          [appCode]="appCode"
                          showUploadButton="true"
                          [showCancelButton]="true"
                          chooseLabel="Select a File"
                          uploadLabel="Start Upload"
                          cancelLabel="Remove All"
                          mode="advanced"
                          (onSelect)="onSelectFile($event, cdx_file_upload)"
                          (onUpload)="onUploadFile($event)"
                          (onError)="onErrorFile($event)"
                          (onClear)="onClearFile()"
                          [maxFileSize]="15000000"
                          displayMessage="Maximum single file size supported: 15 MB"
                          (finalMetaData)="finalMeta($event)"
                          [showErrorAlert]="true"
                          accept=".dat,.txt"
                          continueLabel="Continue"
                          [cdx]="true">
        </fm-s3-fileupload>
      </div>
    </div>

    <br>

    <div class="btnAlign" >
      <button fmButton type="button" routerLink="/reverseMortgage" [small]="true" label="Cancel"
              class="dispbuttonMargin"></button>
    </div>
    <br><br>
  </div>
</div>
<div *ngIf="isSuccess">

  <div >
    <table width="67%" class="centerAlign">
      <tbody><tr>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td class="messageInformation">
          The following File has been uploaded...
        </td>
      </tr>

      <tr> <td class="bodyText">
        <span class="boldText">File Name:</span>&nbsp;{{fileName}}
      </td></tr>

      <tr>
        <td>&nbsp;</td>
      </tr>

      <tr>
        <td class="messageInformation">Your tracking number is shown below. Please keep this number for your records and use it to reference your submission. </td>
      </tr>

      <tr> <td class="bodyText">
        <span class="boldText">Tracking Id:</span>&nbsp; &nbsp;	   {{trackingId}}
      </td></tr>

      <tr> <td class="bodyText">
        {{totRecord}} record(s) were transmitted
      </td></tr>

      <tr>
        <td>&nbsp;</td>
      </tr>

      <tr>
        <td>&nbsp;</td>
      </tr>

      <tr>
        <td class="messageInformation">Warning:  Do not hit the Back button, it will resubmit your uploaded file.  To view the status and contents of your file, go to the View Transmission screen.</td>
      </tr>

      </tbody></table>
      <br><br>
  </div>
</div>
